<template>
  <Row
    class="page3 disfinancingtrade"
    style="padding-left: 4vw; padding-right: 4vw; flex: 1; height: 100%"
  >
  <div
      style="
        display: flex;
        align-items: center;
        position: fixed;
        z-index: 88;
        left: 0;
        top: 2.5vw;
      "
    >
      <div class="changeWrap">
        <!-- <img :src="$images.change" alt="" /> -->
        <!-- <span>切换</span> -->
      </div>
      <div style="display: flex; align-items: center" v-if="false">
        <img
          @click="$router.back()"
          :src="$images.logo"
          style="width: 3vw; height: 3vw; cursor: pointer"
          alt=""
        />
        <Select
          style="width: 100px"
          placeholder="请选择年份"
          class="myselect"
          v-model="year"
        >
          <Option :value="item" v-for="item in arrYear" :key="item">{{
            item
          }}</Option>
        </Select>
        <Select
          style="width: 100px"
          placeholder="Select Month"
          class="myselect"
          v-model="month"
        >
          <Option :value="item" v-for="item in arrMonth" :key="item">{{
            item
          }}</Option>
        </Select>
        <Button
          @click="getList()"
          type="warning"
          ghost
          style="
            cursor: pointer;
            margin-left: 15px;
            color: #bf9d63;
            border: solid 1px #bf9d63;
          "
        >
          完成
        </Button>
      </div>
    </div>
    <div class="box_container" style="height: 100%">
      <div class="left_container" style="height: 100%">
        <!-- <div class="see_all">查看全部</div> -->
        <div class="headListWrap" style="overflow-y: auto; height: 100%">
          <div v-for="(item, index) in list" style="margin-bottom: 1vw">
            <div
              class="side_item"
              :class="[item.check? 'is_check' : '']"
              @click="getCurrentItem(item, index)"
            >
              <div>{{ item.fileName }}</div>
              <div
                class="item_operate"
                :class="[item.confirm == 0 ? 'is_not_orperate' : '']"
              >
                {{ item.confirm == 0?'未审':item.confirm == 1?'AI已审':"人工已审" }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right_container" v-if="list.length > 0">
        <div class="content_left">
          <div class="title_content">{{ currentItem.fileName }}</div>
          <div
            class="pdf-container"
            ref="wrapper"
            @wheel.prevent="scaleWheel($event)"
          >
            <div
              class="trade_content box"
              ref="box"
              @mousedown="dragstart($event)"
            >
              <!-- <img :src="imgurl" class="trade_img" /> -->
              <vue-pdf-embed
                :source="currentItem.pdfUrl"
                class="trade_img"
                :page="currentNum"
              />
            </div>
          </div>
          <div class="trade_footer">
            <div class="icon_box"></div>
            <div class="icon_box">
              <div class="left-iocn" @click="prePage()"></div>
              <div class="right-iocn" @click="nextPage()"></div>
            </div>
            <div class="page-box">页码 {{ currentNum }}/{{ total }}</div>
          </div>
        </div>
        <div class="content_right">
          <div style="display: flex; flex-direction: column">
            <div class="title_content">预警页码</div>
            <div style="margin-top: 18px;display:flex;flex-wrap: wrap;">
              <el-tag @click="changeCurrentNum(item)" type="warning" style="cursor: pointer;margin-left:10px;" v-for="(item, idx) in currentItem.warningPageList" :key="idx">{{ item }}</el-tag>
            </div>
            <div class="title_content" style="margin-top:10px;">理由</div>
            <div style="margin-top: 18px">
              <el-input
                :disabled="currentItem.confirm == 2"
                v-model="currentItem.contractList[currentNum-1].limResult"
                :rows="12"
                type="textarea"
                placeholder="理由文本"
                style="background: rgba(87, 87, 87, 0.5); color: #fff"
              />
            </div>
            <div class="title_content" style="margin-top: 10px">操作</div>
            <div style="margin-top: 18px">
              <el-select
                :disabled="currentItem.confirm == 2"
                v-model="currentItem.contractList[currentNum-1].report"
                style="width: 100%"
                placeholder="请选择"
                size="large"
              >
                <el-option
                  v-for="(item, index) in options"
                  :key="index"
                  :value="item.value"
                  :label="item.label"
                />
              </el-select>
            </div>
          </div>
          <div style="display: flex; flex-direction: row-reverse">
            <el-button
              @click="confirmStatus()"
              :disabled="currentItem.confirm == 2"
              :style="
                currentItem.confirm == 2
                  ? ``
                  : `background: #bf9d63; color: #fff;`
              "
              style="width: 4vw; height: 2vw"
              >确定</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </Row>
</template>

<script>
import { useDataStore } from "@/store";
import { mapActions } from "pinia";
import VuePdfEmbed from "vue-pdf-embed/dist/vue2-pdf-embed";
import * as pdfjsLib from "pdfjs-dist";
pdfjsLib.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.js`;

import { queryGmgjContract,gmContractConfirm } from "../api/index";
import { Message } from "element-ui";

export default {
  name: "page3",
  components: {
    VuePdfEmbed,
  },
  created() {
    let year = new Date().getFullYear();
    let month = new Date().getMonth() + 1;
    let day = new Date().getDate();
    if (this.companyDomestic == "境内") {
      if (day <= 7) {
        if (month == 1) {
          month = 11;
          year--;
        } else if (month == 2) {
          month = 12;
          year--;
        } else {
          month = month - 2;
        }
      } else {
        if (month == 1) {
          month = 12;
          year--;
        } else {
          month--;
        }
      }
    } else {
      if (day <= 15) {
        if (month == 1) {
          month = 11;
          year--;
        } else if (month == 2) {
          month = 12;
          year--;
        } else {
          month = month - 2;
        }
      } else {
        if (month == 1) {
          month = 12;
          year--;
        } else {
          month--;
        }
      }
    }

    if (month < 10) {
      month = "0" + month;
    }
    this.year = year;
    this.month = month + "";
    let beforeYear = year - 50;
    let arrYear = [];
    while (beforeYear < year) {
      arrYear.push(year--);
    }
    arrYear = arrYear.filter((item) => item > 2020);
    this.arrYear = arrYear;
    let arrMonth = [];
    for (let i = 1; i <= 12; i++) {
      let month2 = i < 10 ? "0" + i : "" + i;
      arrMonth.push(month2);
    }
    this.arrMonth = arrMonth;
    this.setTitle("异常贸易判别");
 
    this.setLeftTop(false)
    this.filename = this.$route.query.filename
    this.getList()
  },
  data() {
    return {
      filename:undefined,
      list:[],
      arrYear: [],
      year: "",
      month: "",
      dragData: {
        x: 0,
        y: 0,
        left: 0,
        top: 0,
        firstX: 0,
        firstY: 0,
      },
      scaleData: {
        scale: 1,
        scaleNum: 0.1,
        scaleMax: 100,
        scaleMin: 0.1,
        scaleBtn: 0.4,
      },
      total: 0,
      currentNum: 1,
      value: "has",
      options: [
        {
          label: "具备",
          value: "1",
        },
        {
          label: "不具备",
          value: "0",
        },
      ],
      currentItem: {},
      sideList: [
        //         {
        //           name: "具备test",
        //           value: "未审",
        //           check: false,
        //           url: "./具备test.pdf",
        //           have: "no",
        //           reason: `"该合同具备融资性贸易合同的特征。理由如下-->
        // 根据提供的合同片段，可以看到以下内容：
        // 合同有三方或三方以上主体
        // 合同片段中出现"资金占用"、"委托融资"等词汇
        // 合同片段中收货方与付款方（先付款方）不是同一主体
        // 综上所述，根据合同片段分析，该合同具备融资性贸易合同的特征。"`,
        //         },
        {
          name: "DNXS20231101嘉兴海大210吨玉米双签",
          value: "已审",
          check: false,
          url: "./DNXS20231101嘉兴海大210吨玉米双签.pdf",
          have: "yes",
          reason: `"该合同不具备融资性贸易合同的特征。理由如下-->
根据提供的合同片段，可以看到以下内容： 
合同只有两方主体
合同片段中未出现"垫付货款"、"资金占用"、"占用费"、"资金周期"、"委托融资"、"年化收益率"、"循环周期"、"服务费率"等词汇
合同片段未表明陈述、或暗示合同的一方为另一方提供资金垫付
合同片段未出现合同的一方以自身信用向另一方提供资金融通、担保（含抵押、质押等）
综上所述，根据合同片段分析，该合同并不具备融资性贸易合同的特征。"    `,
        },
        {
          name: "DNXS20231116茶陵龙华300吨玉米",
          value: "已审",
          check: false,
          url: "./DNXS20231116茶陵龙华300吨玉米.pdf",
          have: "yes",
          reason: `"该合同不具备融资性贸易合同的特征。理由如下-->
根据提供的合同片段，可以看到以下内容： 
合同只有两方主体
合同片段中未出现"垫付货款"、"资金占用"、"占用费"、"资金周期"、"委托融资"、"年化收益率"、"循环周期"、"服务费率"等词汇
合同片段未表明陈述、或暗示合同的一方为另一方提供资金垫付
合同片段未出现合同的一方以自身信用向另一方提供资金融通、担保（含抵押、质押等）
综上所述，根据合同片段分析，该合同并不具备融资性贸易合同的特征。"    `,
        },
        {
          name: "DNXS20231083曲靖双胞胎1000吨小麦双签",
          value: "已审",
          check: false,
          url: "./DNXS20231083曲靖双胞胎1000吨小麦双签.pdf",
          have: "yes",
          reason: `"""该合同不具备融资性贸易合同的特征。理由如下-->
根据提供的合同片段，可以看到以下内容： 
合同只有两方主体
合同片段中未出现""垫付货款""、""资金占用""、""占用费""、""资金周期""、""委托融资""、""年化收益率""、""循环周期""、""服务费率""等词汇
合同片段未表明陈述、或暗示合同的一方为另一方提供资金垫付
合同片段未出现合同的一方以自身信用向另一方提供资金融通、担保（含抵押、质押等）
综上所述，根据合同片段分析，该合同并不具备融资性贸易合同的特征。""    "
`,
        },
        {
          name: "DNXS20231086正大原料600吨小麦双签",
          value: "已审",
          check: false,
          url: "./DNXS20231086正大原料600吨小麦双签.pdf",
          have: "yes",
          reason: `"""该合同不具备融资性贸易合同的特征。理由如下-->
根据提供的合同片段，可以看到以下内容： 
合同只有两方主体
合同片段中未出现""垫付货款""、""资金占用""、""占用费""、""资金周期""、""委托融资""、""年化收益率""、""循环周期""、""服务费率""等词汇
合同片段未表明陈述、或暗示合同的一方为另一方提供资金垫付
合同片段未出现合同的一方以自身信用向另一方提供资金融通、担保（含抵押、质押等）
综上所述，根据合同片段分析，该合同并不具备融资性贸易合同的特征。""    "
`,
        },
        {
          name: "DNXS20231132上海新邦200吨大麦双签",
          value: "已审",
          check: false,
          url: "./DNXS20231132上海新邦200吨大麦双签.pdf",
          have: "yes",
          reason: `"""该合同不具备融资性贸易合同的特征。理由如下-->
根据提供的合同片段，可以看到以下内容： 
合同只有两方主体
合同片段中未出现""垫付货款""、""资金占用""、""占用费""、""资金周期""、""委托融资""、""年化收益率""、""循环周期""、""服务费率""等词汇
合同片段未表明陈述、或暗示合同的一方为另一方提供资金垫付
合同片段未出现合同的一方以自身信用向另一方提供资金融通、担保（含抵押、质押等）
综上所述，根据合同片段分析，该合同并不具备融资性贸易合同的特征。""    "
`,
        },
      ],
    };
  
  },
  methods: {
    ...mapActions(useDataStore, ["setTitle", "setLeftTop", "setBackurl"]),
    confirmStatus(){
      gmContractConfirm({
        confirm:2,
        contractList:this.currentItem.contractList,
        fileName:this.currentItem.fileName,
        // dateColumn:this.year+'-'+this.month
      }).then(res=>{
        if(res.code == 200){
          Message.success('保存成功')
          this.getList()
        }
      })
    },
    changeCurrentNum(item){
      this.currentNum = Number(item)
    },
    getList(){
      queryGmgjContract({
        page:1,
        pageSize:9999,
        fileName:this.filename,
        // dateColumn:this.year+'-'+this.month
      }).then(res=>{
        if(res.code == 200){
          this.list = res.data.list
          this.list[0].check = true
          this.currentItem = this.list[0];
          this.$nextTick(() => {
            this.getPdf(this.currentItem.pdfUrl);
          });
        }
      })
    },
    move(event) {
      const box = this.$refs.box;
      this.dragData.left = event.pageX - this.dragData.x;
      this.dragData.top = event.pageY - this.dragData.y;
      box.style.left = this.dragData.left + "px";
      box.style.top = this.dragData.top + "px";
    },

    dragstart(e) {
      const _this = this;
      this.$refs.box.style.transition = "none";
      e.preventDefault();
      const box = this.$refs.box;
      // const wrapper = refs.wrapper.value as HTMLElement;
      this.dragData.x = e.pageX - box.offsetLeft;
      this.dragData.y = e.pageY - box.offsetTop;

      document.addEventListener("mousemove", _this.move);
      document.addEventListener("mouseup", function () {
        document.removeEventListener("mousemove", _this.move);
      });

      document.addEventListener("mouseout", function () {
        document.removeEventListener("mousemove", _this.move);
      });
    },
    scaleWheel(e) {
      let dy = -e.deltaY || e.wheelDeltaY;
      if (dy < 0) {
        this.scaleData.scale -= this.scaleData.scaleNum;
      } else {
        this.scaleData.scale += this.scaleData.scaleNum;
      }
      if (this.scaleData.scale >= this.scaleData.scaleMax) {
        this.scaleData.scale = this.scaleData.scaleMax;
        return;
      }
      if (this.scaleData.scale <= this.scaleData.scaleMin) {
        this.scaleData.scale = this.scaleData.scaleMin;
        return;
      }
      this.boxTransform();
      return false;
    },
    boxTransform() {
      this.$refs.box.style.transform = `translate(0, 0) scale(${this.scaleData.scale})`;
    },
    getPdf(url) {
      this.scaleData.scale = 1;
      this.$refs.box.style.left = 0;
      this.$refs.box.style.top = 0;
      this.boxTransform();
      const _this = this;
      // 获取PDF文档信息
      pdfjsLib
        .getDocument({
          url: url,
        })
        .promise.then((pdfDocument) => {
          const numPages = pdfDocument.numPages;
          _this.total = numPages;
          _this.currentNum = 1;
        })
        .catch((error) => {
          console.error("获取PDF文档信息时出错:", error);
        });
    },
    getCurrentItem(item, _index) {
      this.list.forEach((item, index) => {
        item.check = _index === index ? true : false;
      });
      this.currentItem = item;
      this.getPdf(item.pdfUrl);
    },
    nextPage() {
      if (this.currentNum == this.total) {
        return;
      }
      this.currentNum = this.currentNum + 1;
    },

    prePage() {
      if (this.currentNum == 1) {
        return;
      }
      this.currentNum = this.currentNum - 1;
    },
  },
  mounted() {},
  beforeDestroy() {},
};
</script>
<style lang="less">
.disfinancingtrade {
  .myselect {
  margin-left: 15px;
  .ivu-select-selected-value {
  }
  .ivu-select-selection {
    color: #bf9d63;
    background-color: transparent;
    border: 1px solid #bf9d63;
  }
  .ivu-select-placeholder {
    color: #bf9d63 !important;
  }
}
  .changeWrap {
  display: flex;
  align-items: center;
  padding-left: 80px;
  position: relative;
  z-index: 20;
  img {
    width: 16px;
    cursor: pointer;
  }
  span {
    cursor: pointer;
    padding-left: 5px;
    font-size: 14px;
    color: #bf9d63;
  }
}
  .el-textarea__inner {
    color: #fff;
    background-color: rgba(87, 87, 87, 0.5);
  }
  .el-input__inner {
    background: rgba(87, 87, 87, 0.5);
    color: #fff;
  }
}
</style>
<style lang="less" scoped>
@import "~@/assets/less/index.less";
.headListWrap {
  &::-webkit-scrollbar {
    width: 2px;
    height: 2px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
    -webkit-border-radius: 2em;
    -moz-border-radius: 2em;
    border-radius: 2em;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgb(147, 147, 153, 0.5);
    -webkit-border-radius: 2em;
    -moz-border-radius: 2em;
    border-radius: 2em;
  }
}
.box_container {
  width: 100%;
  display: flex;
  height: 100%;
  overflow: hidden;

  .left_container {
    width: 24vw;
    padding: 20px 20px 20px 20px;
    border: 1px solid #4d4a48;
    background: rgba(87, 87, 87, 0.3);

    .see_all {
      color: #bf9d63;
      font-family: Microsoft YaHei;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      margin-bottom: 20px;
    }

    .is_check {
      color: #bf9d63 !important;
      border: 1px solid #bf9d63 !important;
      background: #464440 !important;
    }

    .side_item {
      border-radius: 4px;
      background: #494d52;
      padding: 20px;
      height: 80px;
      border-radius: 4px;
      border: 1px solid #ebebeb;
      // background: #fff;
      display: flex;
      overflow: hidden;
      align-items: center;
      color: #fff;
      cursor: pointer;

      font-family: Microsoft YaHei;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      position: relative;
      padding-right: 4vw;
      &:not(:first-of-type) {
        margin-top: 12px;
      }

      .item_operate {
        background-color: #0bcb74;
        color: #fff;
        font-size: 14px;
        // right: -151px;
        right: -8vw;
        top: 13px;
        position: absolute;
        width: 100%;
        text-align: center;
        transform: rotate(45deg);
        height: 22px;
        line-height: 22px;
      }

      .is_not_orperate {
        background-color: #bfc7ca;
      }
    }
  }

  .right_container {
    flex: 1;
    margin-left: 18px;
    padding: 20px 20px 0px 0px;
    display: flex;
    height: calc(100% - 20px);
    overflow-y: auto;
    background: rgba(87, 87, 87, 0.3);

    .title_content {
      color: #bf9d63;
      font-family: Microsoft YaHei;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }

    .content_left {
      width: 30vw;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      // background-color: #fff;
      padding: 20px;

      .trade_content {
        &::-webkit-scrollbar {
          width: 0px;
          height: 0px;
        }

        &::-webkit-scrollbar-track {
          background-color: transparent;
          -webkit-border-radius: 0em;
          -moz-border-radius: 0em;
          border-radius: 0em;
        }
        &::-webkit-scrollbar-thumb {
          background-color: rgb(147, 147, 153, 0.5);
          -webkit-border-radius: 0em;
          -moz-border-radius: 0em;
          border-radius: 0em;
        }
        flex: 1;
        background: #525659;
        margin-top: 20px;
        padding-top: 20px;
        overflow-y: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow-x: hidden;

        .trade_img {
          width: 90%;
          height: 90%;
        }
      }

      .trade_footer {
        background: #525659;
        height: 60px;
        display: flex;
        padding: 0px 20px;

        .icon_box {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;

          .left-iocn {
            cursor: pointer;
            width: 15px;
            height: 20px;
            background-color: #fff;
            clip-path: polygon(100% 0, 100% 100%, 0 50%);
          }

          .right-iocn {
            cursor: pointer;
            margin-left: 30px;
            width: 15px;
            height: 20px;
            background-color: #fff;
            clip-path: polygon(0 0, 0% 100%, 100% 50%);
          }
        }

        .page-box {
          color: #fff;
          font-family: Microsoft YaHei;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          align-self: center;
          flex: 1;
          text-align: end;
        }
      }
    }

    .content_right {
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      // background-color: #fff;
      padding: 20px;
      justify-content: space-between;
    }
  }
}

.pdf-container {
  position: relative;
  width: 100%;
  height: 100%;

  .box {
    position: absolute;
    width: 100%;
    height: 100%;
  }
}
</style>
